export enum ETemperatureType {
  OBJECT = 'OBJECT',
  SENSOR = 'SENSOR'
}
